import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { FiltersIdentifier, FiltersObject, FilterValue } from "./types"
import type { AutoCloseMessage } from "./reducer"

export const LOADING_STARTED = "loadingStarted"

export const createLoadingStarted = (identifier: string) => ({
    type: LOADING_STARTED,
    payload: {
        identifier: identifier,
    },
})

export const LOADING_ENDED = "loadingEnded"

export const createLoadingEnded = (identifier: string) => ({
    type: LOADING_ENDED,
    payload: {
        identifier: identifier,
    },
})

export const LOADING_ENDED_ERROR = "loadingEndedError"

export const createLoadingEndedError = (identifier: string) => ({
    type: LOADING_ENDED_ERROR,
    payload: {
        identifier: identifier,
    },
})

export const SET_FILTER_VALUE = "SET_FILTER_VALUE"

export const setFilterValue = (identifier: FiltersIdentifier, type: string, filterValue: FilterValue) => ({
    type: SET_FILTER_VALUE,
    payload: {
        identifier: identifier,
        type: type,
        filterValue: filterValue,
    },
})

export const SET_FILTERS = "SET_FILTERS"

export const setFilters = (identifier: FiltersIdentifier, filters: FiltersObject) => ({
    type: SET_FILTERS,
    payload: {
        identifier: identifier,
        filters: filters,
    },
})

export const SET_PAGINATION = "SET_PAGINATION"

export const setPagination = (identifier: FiltersIdentifier, paginationValue: Record<string, any>) => ({
    type: SET_PAGINATION,
    payload: {
        identifier: identifier,
        paginationValue: paginationValue,
    },
})

export const SET_TOTAL_COUNT = "SET_TOTAL_COUNT"

export const setTotalCount = (identifier: FiltersIdentifier, totalCount: number) => ({
    type: SET_TOTAL_COUNT,
    payload: {
        identifier: identifier,
        totalCount: totalCount,
    },
})
// Global filter

export const SET_GLOBAL_DEFAULT_FILTER = "SET_GLOBAL_DEFAULT_FILTER"

export const setGlobalDefaultFilter = (
    locationsIds: string[],
    from: string,
    to: string,
    fromDate: string,
    toDate: string
) => ({
    type: SET_GLOBAL_DEFAULT_FILTER,
    payload: {
        locationsIds: locationsIds,
        from: from,
        to: to,
        fromDate: fromDate,
        toDate: toDate,
    },
})

export const RESET_GLOBAL_FILTER = "RESET_GLOBAL_FILTER"

export const createActionResetGlobalFilter = () => ({
    type: RESET_GLOBAL_FILTER,
})

// Transactions

export const SET_TRANSACTIONS_REPORT_DEFAULT_FILTER = "SET_TRANSACTIONS_REPORT_DEFAULT_FILTER"

export const setTransactionsReportDefaultFilter = () => ({
    type: SET_TRANSACTIONS_REPORT_DEFAULT_FILTER,
})
// Customers

export const SET_CUSTOMERS_REPORT_DEFAULT_FILTER = "SET_CUSTOMERS_REPORT_DEFAULT_FILTER"

export const setCustomersReportDefaultFilter = () => ({
    type: SET_CUSTOMERS_REPORT_DEFAULT_FILTER,
})
// Customers feedback

export const SET_CUSTOMERS_FEEDBACK_REPORT_DEFAULT_FILTER = "SET_CUSTOMERS_FEEDBACK_REPORT_DEFAULT_FILTER"

export const setCustomersFeedbackReportDefaultFilter = () => ({
    type: SET_CUSTOMERS_FEEDBACK_REPORT_DEFAULT_FILTER,
})
// Timesheet

export const SET_TIMESHEET_REPORT_DEFAULT_FILTER = "timesheet/setTimesheetReportFilter"

export const setTimesheetReportDefaultFilter = () => ({
    type: SET_TIMESHEET_REPORT_DEFAULT_FILTER,
})
// Orders

export const SET_ORDERS_REPORT_DEFAULT_FILTER = "SET_ORDERS_REPORT_DEFAULT_FILTER"

export const setOrdersReportDefaultFilter = () => ({
    type: SET_ORDERS_REPORT_DEFAULT_FILTER,
})
// Cash Report

export const SET_CASH_REPORT_DEFAULT_FILTER = "cashReport/setFilter"

export const setCashReportDefaultFilter = () => ({
    type: SET_CASH_REPORT_DEFAULT_FILTER,
})
// Summary

export const SET_SUMMARY_REPORT_DEFAULT_FILTER = "SET_SUMMARY_REPORT_DEFAULT_FILTER"

export const setSummaryReportDefaultFilter = () => ({
    type: SET_SUMMARY_REPORT_DEFAULT_FILTER,
})
// Sales By Items Report

export const SET_SALES_BY_ITEMS_REPORT_DEFAULT_FILTER = "salesByItems/setFilter"

export const setSalesByItemsReportDefaultFilter = () => ({
    type: SET_SALES_BY_ITEMS_REPORT_DEFAULT_FILTER,
})
// Special Pricings Report

export const SET_SPECIAL_PRICING_REPORT_DEFAULT_FILTER = "specialPricingReport/setFilter"

export const setSpecialPricingReportDefaultFilter = () => ({
    type: SET_SPECIAL_PRICING_REPORT_DEFAULT_FILTER,
})
// Voids Report

export const SET_VOIDS_REPORT_DEFAULT_FILTER = "voids/setFilter"

export const setVoidsReportDefaultFilter = () => ({
    type: SET_VOIDS_REPORT_DEFAULT_FILTER,
})
// Employees

export const SET_EMPLOYEES_DEFAULT_FILTER = "SET_EMPLOYEES_DEFAULT_FILTER"

export const setEmployeesDefaultFilter = () => ({
    type: SET_EMPLOYEES_DEFAULT_FILTER,
})

export const AUTO_CLOSE_MESSAGE_TOGGLE = "autoCloseMessage/toggle"

export const autoCloseMessageToggle = (autoCloseMessage: Maybe<AutoCloseMessage>) => ({
    type: AUTO_CLOSE_MESSAGE_TOGGLE,
    payload: {
        autoCloseMessage: autoCloseMessage,
    },
})
